import { FC } from "react";
import { FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import MultiselectOption from "../shared/MulitselectOption";
import { FormSection } from "../shared/FormLayout";
import { AppNames } from "../core/AppConfig";

const permissions = [
  "SprinklerValve.Report.Read",
  "PressureSignals.Read",
  "Entity.Read",
  "Signals.Read"
];

type Props = {
  tenants: any[];
  sites: any[];
  siteOptions: any[];
  selectedApplications: any[];
  setSelectedApplications: (v: any[]) => void;
  fullAccessTenants: any[];
  setFullAccessTenants: (v: any[]) => void;
  selectedTenants: any[];
  setSelectedTenants: (v: any[]) => void;
  selectedSites: any[];
  setSelectedSites: (v: any[]) => void;
  isPublic: boolean;
  setIsPublic: (v: boolean) => void;
  selectedPermissions: string[];
  setSelectedPermissions: (v: string[]) => void;
};

const namesOf = (items: any[], allLabel: string, total: number) => (values: any) =>
  values.length === total
    ? allLabel
    : values.map((value: any) => items.find((item) => item.id === value)?.name).join(", ");

// Access fields shared by the profile editor and "new profile" in the phone account editor.
export const ProfileAccessFields: FC<Props> = (p) => (
  <>
    <FormSection title="Tilgang">
      <Grid item xs={12} md={6}>
        <MultiselectOption
          variant="outlined"
          size="small"
          dense
          fullWidth
          label="Applikasjoner"
          values={p.selectedApplications}
          onChange={p.setSelectedApplications}
          items={AppNames.map((app) => ({ label: app, value: app }))}
          selectAllLabel="Alle applikasjoner"
          renderSelectedValues={(values: any) =>
            values.length === AppNames.length ? "Alle applikasjoner" : values.join(", ")
          }
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MultiselectOption
          variant="outlined"
          size="small"
          dense
          fullWidth
          label="Full tilgang til tenants"
          values={p.fullAccessTenants}
          onChange={p.setFullAccessTenants}
          items={p.tenants.map((tenant) => ({ label: tenant.name, value: tenant.id }))}
          selectAllLabel="Alle tenants"
          renderSelectedValues={namesOf(p.tenants, "Alle tenants", p.tenants.length)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MultiselectOption
          variant="outlined"
          size="small"
          dense
          fullWidth
          label="Tenants"
          values={p.selectedTenants}
          onChange={p.setSelectedTenants}
          items={p.tenants.map((tenant) => ({ label: tenant.name, value: tenant.id }))}
          selectAllLabel="Alle tenants"
          renderSelectedValues={namesOf(p.tenants, "Alle tenants", p.tenants.length)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MultiselectOption
          variant="outlined"
          size="small"
          dense
          fullWidth
          label="Sites"
          values={p.selectedSites}
          onChange={p.setSelectedSites}
          items={p.siteOptions.map((site) => ({ label: site.name, value: site.id }))}
          selectAllLabel="Alle sites"
          renderSelectedValues={namesOf(p.sites, "Alle sites", p.siteOptions.length)}
        />
      </Grid>
    </FormSection>

    <FormSection title="Offentlig profil">
      <Grid item xs={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={p.isPublic}
              onChange={(_, v) => p.setIsPublic(v)}
              color="primary"
            />
          }
          label="Offentlig profil"
        />
        <Typography variant="body2" color="text.secondary">
          Offentlige profiler brukes til å lage URL-er som er tilgjengelige uten innlogging.
        </Typography>
      </Grid>
      {p.isPublic && (
        <Grid item xs={12} md={6}>
          <MultiselectOption
            variant="outlined"
            size="small"
            dense
            fullWidth
            label="Tillatelser"
            values={p.selectedPermissions}
            onChange={p.setSelectedPermissions}
            items={permissions.map((permission) => ({ label: permission, value: permission }))}
            selectAllLabel="Alle tillatelser"
            renderSelectedValues={(values: any) =>
              values.length === permissions.length ? "Alle tillatelser" : values.join(", ")
            }
          />
        </Grid>
      )}
    </FormSection>
  </>
);
